import TKViewport from '@tk/basics/tk.viewport';

export default class DIWViewport extends TKViewport {
    constructor() {
        super();

        this.breakpoints = new Map([
            ['xs', 576],
            ['s', 768],
            ['m', 992],
            ['l', 1200],
            ['xl', 1920],
        ]);
    }
}
